import { DatePicker } from "antd";
import { flow, Option, pipe } from "fp";
import * as Moment from "moment";
import React from "react";
import { useHistory } from "react-router-dom";
import { createGlobalStyle } from "styled-components";

import { Company } from "~/Company";
import {  DisabledTable, shouldShowSelectAFilterPrompt } from "~/DisabledTable";
import { FilterRow } from "~/Filter";
import * as Layout from "~/Layout";
import * as Log from "~/Log";
import * as Preferences from "~/Preferences";
import { Time } from "~/Time";
import { Column } from "./Table";

export const Component = () => {
  const updateFilters = Preferences.Put.use();
  const [ loadingFilters, userPreferences] = Preferences.Get.useLoading()
  const { company } = Company.use();

  const onFilterByBranch = (
    filteredBranchIds: Company.Branch.Branches.BranchIDs
  ) => {
    const filterPreferences = {
      [`${Preferences.preferenceKey("branchFilter")}`]: filteredBranchIds,
    };
    updateFilters.request(
      {
        ...userPreferences,
        ...filterPreferences,
      },
      "Unassigned Logs Table",
      "branchFilter"
    );
  };

  const onFilterByAsset = (
    filteredAssetIds: Company.Assets.Filter.AssetIDs
  ) => {
    const filterPreferences = {
      [`${Preferences.preferenceKey("assetFilter")}`]: filteredAssetIds,
    };
    updateFilters.request(
      {
        ...userPreferences,
        ...filterPreferences,
      },
      "Unassigned Logs Table",
      "assetFilter"
    );
  };

  const disableMissingLogs = shouldShowSelectAFilterPrompt({
    companyId: company.id,
    userPreferences,
    isPageUnassignedLogs: true,
  })

  return (
    <Layout.Page.Component all>
      <FilterRow>
        <Company.Branch.Branches.Filter.Component
          onFilter={onFilterByBranch}
          label="Asset's Branch"
        />
        <Company.Assets.Filter.Component onFilter={onFilterByAsset} />
      </FilterRow>
      <Layout.Section.Component>
        <Header.Component />

        { disableMissingLogs ? 
          (<DisabledTable isLoading={loadingFilters} columns={Column.list() as never} disabledText={"Please select a branch or asset filter to view unassigned logs"} />) 
          : (<Log.Unassigned.Table.Component />)
          }
      </Layout.Section.Component>
    </Layout.Page.Component>
  );
};
namespace Header {
  export const Component = () => {
    const interval = Log.Unassigned.Route.useRouteInterval();
    return (
      <Layout.Section.Header.Component
        Right={Log.Unassigned.Download.Component}
      >
        <Layout.Section.Header.Title>
          <Interval {...interval} />
        </Layout.Section.Header.Title>
      </Layout.Section.Header.Component>
    );
  };

  export function Interval({ interval }: Time.Interval.Stopped) {
    const history = useHistory();
    return (
      <DatePicker.RangePicker
        allowClear={false}
        allowEmpty={[false, false]}
        defaultValue={[
          Moment.default(interval.start.dateTime),
          Moment.default(interval.stop.dateTime),
        ]}
        onChange={flow(
          Option.fromNullable,
          Option.chain(([start, stop]) =>
            start && stop ? Option.some({ start, stop }) : Option.none
          ),
          Option.map(({ start, stop }) =>
            pipe(
              {
                interval: {
                  start: Time.DateTime.fromNumber(start.valueOf()),
                  stop: Time.DateTime.fromNumber(stop.valueOf()),
                },
              } as Time.Interval.Stopped,
              (interval) =>
                history.push(Log.Unassigned.Route.href({ ...interval }))
            )
          )
        )}
      />
    );
  }
}

// TODO: Determine if Product wants to keep this summary and then whether we can optimize its performance enough to allow it to be included again.
// namespace Count {
//   export const Component = () => {
//     const count = Log.Unassigned.Count.use();
//     return (
//       <Container.Component>
//         <Layout.Column.Component span={8}>
//           <Layout.Section.Container.Component all>
//             <Statistic
//               Title={() => <>Duration</>}
//               Value={() => <Duration.Component {...count} />}
//             />
//           </Layout.Section.Container.Component>
//         </Layout.Column.Component>
//         <Layout.Column.Component span={8}>
//           <Layout.Section.Container.Component all>
//             <Statistic
//               Title={() => <>Distance</>}
//               Value={() => <Distance {...count} />}
//             />
//           </Layout.Section.Container.Component>
//         </Layout.Column.Component>
//         <Layout.Column.Component span={8}>
//           <Layout.Section.Container.Component all>
//             <Statistic
//               Title={() => <>Assets</>}
//               Value={() => <>{count.assets}</>}
//             />
//           </Layout.Section.Container.Component>
//         </Layout.Column.Component>
//       </Container.Component>
//     );
//   };

//   namespace Container {
//     export const Component = styled(Layout.Row.Component)`
//       border-bottom: 1px solid ${Color.veryWhiteGrey()};
//       & > div {
//         border-right: 1px solid ${() => Color.veryWhiteGrey()};
//         &:last-of-type {
//           border-right: none;
//         }
//       }
//     `;
//   }

//   namespace Duration {
//     export const Component: Component<Log.Unassigned.Count.Count> = (
//       unassigned
//     ) => {
//       const days = Math.floor(Time.Duration.toDays(unassigned));
//       const time = Time.Duration.toHMMSS(unassigned);
//       return (
//         <>
//           {days > 0 ? <>{days}d </> : null}
//           {time}
//         </>
//       );
//     };
//   }
// }

export namespace LegacyOverride {
  export const Component = createGlobalStyle`
    #view.unassigned {
      padding: 0;
    }
  `;
}
